__webpack_require__.p = "https://ict-lms.briotouch.com/";